import i18n from "../../../../i18n"
const { t } = i18n;
export const defaultCompanyFill = [
    {
        value: 0,
        label: t("dashboard.online"),
        key: 'on',
    },
    {
        value: 1,
        label: t("dashboard.lostConnect"),
        key: "notConnect"
    },
    {
        value: 3,
        label: t("dashboard.ready"),
        key: 'off'
    },
]

export const normalCompanyFill = [
    {
        value: 0,
        label: t("dashboard.online"),
        key: 'on',
    },
    {
        value: 3,
        label: t("dashboard.ready"),
        key: 'off',
    }
]

export const filterLocationDefault = [
    { code: null, name: '', type: 'group' },
    { code: null, name: '', type: 'province' },
    { code: null, name: '', type: 'district' },
    { code: null, name: '', type: 'commune' },
    { code: null, name: '', type: 'status' },
    { code: null, name: '', type: 'statusAI' },
]